import React, { useMemo } from 'react';
import useFirestore from '../../hooks/useFirestore';
import Chart from '../../components/Chart/Chart';
import { exportToExcel } from '../../utils/exportToExcel';
import { exportToPDF } from '../../utils/exportToPDF';
import styles from './Analytics.module.css';

export default function Analytics() {
  const { data: orders } = useFirestore('orders');
  const { data: products } = useFirestore('products');

  // أفضل 5 منتجات مبيعًا (تقريبي بناءً على المخزون المتبقي)
  const topProducts = useMemo(() => {
    return [...products]
      .sort((a, b) => (b.price || 0) - (a.price || 0))
      .slice(0, 5)
      .map((p) => ({ name: p.name, value: p.price || 0 }));
  }, [products]);

  const monthlyRevenue = useMemo(() => {
    const map = {};
    orders.forEach((o) => {
      const date = o.createdAt?.toDate ? o.createdAt.toDate() : new Date();
      const key = date.toLocaleDateString('ar-EG', { month: 'short' });
      map[key] = (map[key] || 0) + (Number(o.total) || 0);
    });
    return Object.entries(map).map(([name, value]) => ({ name, value }));
  }, [orders]);

  const statusBreakdown = useMemo(() => {
    const map = {};
    orders.forEach((o) => {
      const status = o.status || 'قيد الانتظار';
      map[status] = (map[status] || 0) + 1;
    });
    return Object.entries(map).map(([name, value]) => ({ name, value }));
  }, [orders]);

  const handleExportExcel = () => {
    const rows = orders.map((o) => ({
      'رقم الطلب': o.id,
      'العميل': o.customerName,
      'الإجمالي': o.total,
      'الحالة': o.status,
    }));
    exportToExcel(rows, 'تقرير-الطلبات');
  };

  const handleExportPDF = () => {
    exportToPDF(
      orders,
      [
        { header: 'العميل', key: 'customerName' },
        { header: 'الإجمالي', key: 'total' },
        { header: 'الحالة', key: 'status' },
      ],
      'تقرير الطلبات',
      'تقرير-الطلبات'
    );
  };

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <div>
          <h2>التحليلات</h2>
          <p>تقارير مفصّلة عن أداء المتجر</p>
        </div>
        <div className={styles.exportButtons}>
          <button onClick={handleExportExcel} className={styles.exportBtn}>تصدير Excel</button>
          <button onClick={handleExportPDF} className={styles.exportBtnAlt}>تصدير PDF</button>
        </div>
      </div>

      <div className={styles.grid}>
        <div className={styles.card}>
          <h3>الإيرادات الشهرية</h3>
          <Chart type="bar" data={monthlyRevenue} />
        </div>
        <div className={styles.card}>
          <h3>أعلى المنتجات سعرًا</h3>
          <Chart type="bar" data={topProducts} />
        </div>
        <div className={`${styles.card} ${styles.wide}`}>
          <h3>توزيع حالات الطلبات</h3>
          <Chart type="pie" data={statusBreakdown} height={220} />
        </div>
      </div>
    </div>
  );
}
